module.exports = __webpack_public_path__ + "img/defaultCover.91b64dc3.png";